import $ from 'jquery';
import Noty from 'noty';
import moment from 'moment-timezone';
import equal from 'deep-equal';

import 'vendor/detectmobilebrowser';
import 'componentSettings/NotySettings.js';
import history from "services/History";

import Language from 'services/Language.js';

const transliteArr = { '.': '', 'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ж': 'g', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'ы': 'i', 'э': 'e', 'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ж': 'G', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'Ф': 'F', 'Ы': 'I', 'Э': 'E', 'ё': 'yo', 'х': 'h', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ъ': '', 'ь': '', 'ю': 'yu', 'я': 'ya', 'Ё': 'YO', 'Х': 'H', 'Ц': 'TS', 'Ч': 'CH', 'Ш': 'SH', 'Щ': 'SHCH', 'Ъ': '', 'Ь': '', 'Ю': 'YU', 'Я': 'YA', ' ': '-' };
const transliteReplacer = function (a) { return transliteArr.hasOwnProperty(a) ? transliteArr[a] : a };
const transliteReg = /[А-яёЁ\s\.]/g;

const ConfirmCodeModalWidget = !$('.js-dynamical-modals').length ?
    require('widgets/ConfirmCodeModalWidget.js').default :
    require('widgets/ConfirmCodeModalWidget_v2.js').default;

const ConfirmOrderWithUpdatedTermsModalWidget = require('widgets/ConfirmOrderWithUpdatedTermsModalWidget.js').default;
const RequisiteNotFoundModalWidget = require('widgets/RequisiteNotFoundModalWidget.js').default;
const QRCodeModalWidget = require('widgets/QRCodeModalWidget.js').default;
const CryptoModalVerifications = require('widgets/CryptoModalVerifications.js').default;


Date.prototype.toLocaleFormat = function (format) {
    let f = { y: this.getYear(), Y: this.getFullYear(), m: this.getMonth() + 1, d: this.getDate(), H: this.getHours(), M: this.getMinutes(), S: this.getSeconds() };
    for (let k in f)
        format = format.replace('%' + k, f[k] < 10 ? "0" + f[k] : f[k]);
    return format;
};

let inst = null;

class utils {
    constructor() {
        if (!inst) {
            inst = this;
        }
        return inst;
    }

    static applyUrlQueries(newLocation) {
        let beforeHash = newLocation.split('#')[0] || "";
        const hashNew = newLocation.split('#')[1] || "";
        let hashNewStart = hashNew.split('?')[0] || "";
        const hashNewEnd = hashNew.split('?')[1] || "";
        const hashSearchQuery = location.hash.split('?')[1] || "";
        const searchNew = newLocation.split('?')[1] || "";
        const searchCurrentNew = location.search.split('?')[1] || "";
        let newParams = $.param({
            ...utils.parseQuery(hashSearchQuery),
            ...utils.parseQuery(hashNewEnd),
        });
        let newParamsSearch = $.param({
            ...utils.parseQuery(searchNew),
            ...utils.parseQuery(searchCurrentNew),
        });

        const newParamsSearchParsed = utils.parseQuery(newParamsSearch);
        if (!!newParamsSearchParsed.formId) {
            beforeHash = utils.getLocalizeUrl('/in#/payments/' + newParamsSearchParsed.formId);
            hashNewStart = '';
            newParams = '';
            newParamsSearch = '';
        }

        return beforeHash +
            ((newParamsSearch && false) ? ('?' + newParamsSearch) : '') +
            ((hashNewStart + newParams)
                ? (hashNewStart + (newParams ? '?' : '') + newParams)
                : ""
            );
    }

    static getRandom(count) {
        return parseInt(Math.random() * count, 10);
    }

    static getRandomFromRange(min, max) {
        if (max < min) {
            [max, min] = [min, max];
        }
        return (min + utils.getRandom((max - min) + 1));
    }

    static toEnglishTime(time) {
        let [hours, minutes] = time.split(":")
            .map((item) => {
                return parseInt(item, 10);
            });
        let postfix = 'am';
        if (hours === 24) {
            hours = 0;
        }
        if (hours === 12 && minutes === 0) {
            postfix = '(Noon)';
        }
        if (hours > 12 || (hours === 12 && minutes > 0)) {
            postfix = 'pm';
        }
        if (hours >= 13) {
            hours -= 12;
        }
        if (hours === 0) {
            hours = 12;
        }
        if (hours === 0 && minutes === 0) {
            hours = 12;
            minutes = 0;
            postfix = 'pm';
        }

        return (utils.leadingZero(hours, 2) + ':' + utils.leadingZero(minutes, 2)) + ' ' + postfix;
    }

    static formatFormErrors(formsError) {
        if (formsError && Object.keys(formsError).length) {
            return Object.keys(formsError)
                .map((key) => {
                    const item = formsError[key];
                    return key + ": " + ((item && item[0] && item[0].errorText) ? item[0].errorText : "");
                }).join("<br>");
        }
        return "";
    }

    static isMobile() {
        return $.browser.mobile;
    }

    static isMobileTablet() {
        return $.browser.mobileTablet;
    }

    static isMobileAndroid() {
        return /android/i.test(navigator.userAgent || navigator.vendor || window.opera);
    }

    static isMobileApple() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera);
    }

    static isMobileView() {
        return !!$('.mobileView').length;
    }

    static app_noty(newMessage) {
        let message = Object.assign({}, newMessage);
        if (message.text instanceof Array) {
            for (var i in message.text) {
                if (window.$$noticeMessage && window.$$noticeMessage.show) {
                    window.$$noticeMessage.show(message.text[i].message, message.text[i].type);
                } else {
                    new Noty({ text: message.text[i].message, type: message.text[i].type }).show();
                }
            }
        } else {
            message.type = (message.type === 'danger') ? 'error' : message.type;
            message.type = (message.type === 'info' || message.type === 'sendConfirmCode' || message.type === 'updatedConditions' || message.type === 'requisiteNotFound') ? 'information' : message.type;
            if (window.$$noticeMessage && window.$$noticeMessage.show) {
                window.$$noticeMessage.show(message.text, message.type);
                console.log('custom noty!')
            } else {
                console.log('noty!');
                new Noty({ text: message.text, type: message.type }).show();
            }
        }
    }

    static blockMouseEvents(obj) {
        obj.attr('onclick', 'return false;');
        obj.css('pointer-events', 'none');
    }

    static unblockMouseEvents(obj) {
        obj.removeAttr('onclick');
        obj.css('pointer-events', 'auto');
    }

    static setTimerBlock(obj, seconds) {
        let interval = false;
        seconds = parseInt(seconds);
        obj.prop('disabled', true);
        let prevHtml = obj.html();
        obj.css({ 'min-width': '25px', 'cursor': 'auto', 'pointer-events': 'none' });
        obj.attr('onclick', 'return false;');
        let onInterval = function () {
            if (seconds > 0) {
                obj.html('(' + seconds + ')');
                seconds--;
            } else {
                obj.prop('disabled', false);
                obj.html(prevHtml);
                obj.removeAttr('style');
                obj.removeAttr('onclick');
                interval && clearInterval(interval);
            }
        };
        onInterval();
        interval = setInterval(onInterval, 1000);
    }

    static number_format(number, decimals, dec_point, thousands_sep) {
        number = (number + '')
            .replace(/[^0-9+\-Ee.]/g, '');
        let n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            toFixedFix = function (n, prec) {
                let k = Math.pow(10, prec);
                return '' + (Math.round(n * k) / k)
                    .toFixed(prec);
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        let s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
            .split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '')
            .length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1)
                .join('0');
        }
        return s.join(dec);
    }

    static getMoneyFormat(amount, decimals) {
        amount = +amount;
        if (decimals) {
            decimals = +decimals;
        } else {
            decimals = this.decimalCount(amount);
        }
        let moneyVal = this.number_format(amount, decimals, '.', ' ');
        if (moneyVal.indexOf(',') !== -1) {
            moneyVal = moneyVal.replace(/0+$/, '').replace(/,$/, '');
        }
        return moneyVal;
    }
    static delMoneyFormat(amount) {
        const newFormat = amount.replace(/\s/g, '')
        return newFormat;
    }

    static getMoneyFormatForOrdersRatedAmount(mainOrder, asNum) {
        asNum = asNum !== undefined;
        let amount = mainOrder.amount;
        if (mainOrder.rate) {
            amount *= mainOrder.rate;
        }
        if (mainOrder.type === 1) {
            amount = Math.ceil(amount * 100 / 100);
        }
        return asNum ? amount : this.getMoneyFormat(amount, 2);
    }

    static decimalCount(num) {
        let match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) { return 0; }
        return Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0)
            // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0)
        );
    }

    static numToRealStr(number) {
        number = +number;
        let str = number.toString();
        let eIndex = str.indexOf('e');
        if (eIndex !== -1) {
            let eVal = +str.substr(eIndex + 2);
            let dotIndex = str.indexOf('.');
            if (dotIndex !== -1) {
                eVal += eIndex - dotIndex - 1;
            }
            str = number.toFixed(eVal);
        }
        return str.replace('.', ',');
    }

    static parseAmount(amount) {
        amount += "";

        amount = amount.replace(',', '.');
        // let m = amount.match(/^\d*(\.?\d*)?/); // !!! Dose not work in win 10. Matches variously.

        if (amount > "0.00000079") amount = parseFloat(amount);

        return isFinite(amount) ? amount : 0;
    }

    static floor(amount, prec = 0) {
        const acc = Math.pow(10, prec);
        return Math.floor(amount * acc) / acc;
    }

    static ceil(amount, prec = 0) {
        const acc = Math.pow(10, prec);
        return Math.ceil(amount * acc) / acc;
    }

    static app_alert(message) {
        let error = false;
        try {
            let ts = new Date();
            alert(message);
            let te = new Date();
            if (te - ts < 50) {
                error = true;
            }
        } catch (e) {
            error = true;
        }
        if (error) {
            this.app_noty({
                type: 'error',
                text: language.getLabel('L_JS_BROWSER_ALERT_DISABLE')
            });
        }
    }

    static app_confirm(message) {
        let error = false;
        let confirmResult = false;

        try {
            let ts = new Date();
            confirmResult = confirm(message);
            let te = new Date();
            if (te - ts < 50) {
                error = true;
            }
        } catch (e) {
            error = true;
        }
        if (error) {
            this.app_noty({
                type: 'error',
                text: language.getLabel('L_JS_BROWSER_ALERT_DISABLE')
            });
        }
        return confirmResult;
    }

    static app_fetch(ajax) {
        let that = this;
        return $.when(ajax).fail((error) => {
            if (!error.status === 0) {
                const errorObj = {
                    type: 'error',
                    text: Language.getLabel('L_COMMON_FATAL_EXCEPTION'),
                    error: error
                };
                this.app_noty(errorObj);
                return $.Deferred().reject(errorObj).promise();
            }
            return null;
        }).then((resp) => {
            if (resp.type === "success" && resp.reachGoal && typeof ym === 'function' && typeof YM_KEY === 'number') {
                ym(YM_KEY, 'reachGoal', resp.reachGoal);
            }
            if (resp.moveTo) {
                if (resp.text) {
                    that.app_noty(resp);
                    setTimeout(() => {
                        if (resp.moveTo.indexOf('#') !== -1) {
                            let moveTo = resp.moveTo.split('#')[1];
                            if (history.location.pathname !== moveTo) {
                                history.push(utils.applyUrlQueries(resp.moveTo[1]));
                            }
                        } else {
                            window.location.href = utils.applyUrlQueries(resp.moveTo);
                            if ((window.location.pathname + window.location.search).replace(/^\\/, "")
                                === utils.applyUrlQueries(resp.moveTo).replace(/^\\/, "").split('#')[0]) {
                                window.location.reload();
                            }
                            // window.location.reload(); todo: debug it with index page
                        }
                    }, 7000);
                } else {
                        if (resp.moveTo.indexOf('#') !== -1) {
                            let moveTo = resp.moveTo.split('#')[1];
                            if (history.location.pathname !== moveTo) {
                                history.push(utils.applyUrlQueries(resp.moveTo.split('#')[1]));
                            }
                        } else {
                            if (resp.targetBlank) {
                                window.open(utils.applyUrlQueries(resp.moveTo), '_blank');
                            } else {
                                window.location.href = utils.applyUrlQueries(resp.moveTo);
                            }
                            if ((window.location.pathname + window.location.search).replace(/^\\/, "")
                                === utils.applyUrlQueries(resp.moveTo).replace(/^\\/, "").split('#')[0]) {
                                window.location.reload();
                            }
                            // window.location.reload(); todo: debug it with index page
                        }
                }
                return $.Deferred().reject({ type: 'error', reason: 'Force redirect' }).promise();
            } else {
                if (resp.text) {
                    that.app_noty(resp);
                }
            }
            return resp;
        });
    }
    static addendCsrf_TokenIfNeeded(data) {
        if (typeof data === 'string' && !~data.indexOf('csrf_token')) {
            data += '&csrf_token=' + csrfToken;
        }
        if (this.isObject(data)) {
            if (data instanceof FormData) {
                if (!data.has('csrf_token')) {
                    data.append('csrf_token', csrfToken);
                }
            } else {
                if (!data.hasOwnProperty('csrf_token')) {
                    data['csrf_token'] = csrfToken;
                }
            }
        }
        return data;
    }

    static app_post(url, data = {}, extraOptions = {}) {
        const options = Object.assign({
            type: "POST",
            url: url,
        }, extraOptions);
        data = utils.addendCsrf_TokenIfNeeded(data);
        options.data = data;
        return this.app_fetch($.ajax(options));
    }

    static app_get(url, data = {}, options = {}) {
        if (!options.no_csrf_token) {
            data = utils.addendCsrf_TokenIfNeeded(data);
        }
        return this.app_fetch($.get(url, data));
    }

    static app_post_cc(url, data = {}, ccCb = () => { }, settings = {}) {
        data = utils.addendCsrf_TokenIfNeeded(data);
        const options = Object.assign({
            type: "POST",
            url: url,
        }, settings);
        options.data = data;
        return this.app_fetch($.ajax(options)).then((resp) => {
            if (resp.type === 'confirmMethods') {
                ConfirmCodeModalWidget.showConfirmMethodsModal(url, data, ccCb, resp);
            }
            if (resp.type === 'sendConfirmCode') {
                ConfirmCodeModalWidget.showConfirmModal(url, data, ccCb, Object.assign(resp.data.settings, settings), settings);
            }
            if (resp.type === 'updatedConditions') {
                ConfirmOrderWithUpdatedTermsModalWidget.showUpdatedConditionsModal(url, data, ccCb, resp);
            }

            if (resp.type === 'requisiteNotFound') {
                RequisiteNotFoundModalWidget.showRequisiteNotFoundModal(url, data, ccCb, resp);
            }

            if (typeof ccCb === 'function') {
                ccCb(resp);
            }
            return resp;
        });
    }

    static app_get_cc(url, data = {}, ccCb = () => { }) {
        data = utils.addendCsrf_TokenIfNeeded(data);
        return this.app_fetch($.post(url, data)).then((resp) => {
            if (resp.type === 'sendConfirmCode') {
                ConfirmCodeModalWidget.showConfirmModal(url, data, ccCb, resp.data.settings);
            }
            typeof ccCb === 'function' && ccCb(resp);
            return resp;
        });
    }

    static getDateFromStr(ddmmyyString) {
        if (/^\d\d[-.\/]\d\d[-.\/]\d\d\d\d$/.exec(ddmmyyString)) {
            let parseDate = ddmmyyString.split('/');
            if (!parseDate[1]) {
                parseDate = ddmmyyString.split('.');
            }
            if (!parseDate[1]) {
                parseDate = ddmmyyString.split('-');
            }
            let inputDate = new Date();
            inputDate.setYear(+parseDate[2]);
            inputDate.setMonth(+parseDate[1] - 1);
            inputDate.setDate(+parseDate[0]);
            inputDate.setHours(0);
            inputDate.setMinutes(0);
            inputDate.setSeconds(0);
            inputDate.setMilliseconds(0);
            return inputDate;
        } else {
            return null;
        }
    }

    static getMomentTzFromStr(ddmmyyString, timeZone = window.appSettings.serverTimeZone) {
        if (/^\d\d[-.\/]\d\d[-.\/]\d\d\d\d$/.exec(ddmmyyString)) {
            let parseDate = ddmmyyString.split('/');
            if (!parseDate[1]) {
                parseDate = ddmmyyString.split('.');
            }
            if (!parseDate[1]) {
                parseDate = ddmmyyString.split('-');
            }
            let formatedString = parseDate[2] + '-' + parseDate[1] + '-' + parseDate[0] + ' 00:00:00';
            return moment.tz(formatedString, timeZone);
        }
        return null;
    }

    static getMomentTzFromUnix(time, timeZone = window.appSettings.serverTimeZone) {
        return moment.unix(time).tz(timeZone);
    }

    static getDefaultMomentTzDateFormat() {
        return 'DD/MM/YYYY';
    }

    static getDefaultDateFormat() {
        return '%d/%m/%Y';
    }

    static formatDate(date) {
        date = new Date(date * 1000);
        return `${utils.leadingZero(date.getDate(), 2)}.${utils.leadingZero(date.getMonth() + 1, 2)}.${date.getFullYear()}`;
    }

    static nameValueArrayToObj(arr) {
        let result = {};
        arr.map((el) => {
            result[el.name] = el.value;
        });
        return result;
    }

    static getHMString(time, withSec) {
        let hours = 0;
        let minutes = 0;
        let minutesStr = '00';
        let seconds = 0;
        let secondsStr = '';
        if (time > 0) {
            hours = Math.floor(time / 3600);
            minutes = Math.floor((time % 3600) / 60);
            minutesStr = minutes < 10 ? "0" + minutes : minutes;
            if (withSec) {
                seconds = Math.floor(time % 60);
                secondsStr = seconds < 10 ? " 0" + seconds : ' ' + seconds;
            }
        }
        let resultString = "";
        let hString = Language.getLabel('L_DATE_H');
        let mString = Language.getLabel('L_DATE_M');
        let sString = Language.getLabel('L_DATE_S');
        if (hours > 0) {
            resultString += hours + ' ' + hString + '.';
            resultString += ' ' + minutesStr + ' ' + mString + '.';
            if (withSec) {
                resultString += ' ' + secondsStr + sString + '.';
            }
        } else {
            if (minutes > 0) {
                resultString += minutesStr + ' ' + mString + '.';
                if (withSec) {
                    resultString += ' ' + secondsStr + sString + '.';
                }
            } else {
                if (withSec) {
                    resultString += secondsStr + sString + '.';
                }
            }
        }
        return resultString ? resultString : '0 ' + hString + ' 0 ' + mString + (withSec ? ' 0' + sString : '');
    }

    static createIdRawStore(array = [], keyProperty = "id") {
        let cloneArray = array.slice(0);
        let store = new Map();
        // let store = {
        //     byId: {},
        //     raw: cloneArray
        // };
        cloneArray.map((el) => {
            //store.byId[el.id] = el;
            store.set(el[keyProperty], el);
        });
        return { data: store };
    }

    static createLoadingStore() {
        return {
            loaded: false,
            isLoading: true,
        }
    }

    static getPluralValue(value) {
        let result = 1;
        if (((value % 100) >= 11 && (value % 100) <= 19) ||
            (value % 10 === 0) ||
            (value % 10 >= 5 && value % 10 <= 9)) {
            return 5;
        }
        if (value % 10 >= 2 && value % 10 <= 4) {
            return 2;
        }
        if (value % 10 === 1) {
            return 1;
        }
        return result;
    }

    static mapToArray(mapObject) {
        const arr = [];
        for (let el of mapObject.values()) {
            arr.push(el);
        }
        return arr;
    }

    static nl2br(str) {
        return str.replace(/([^>])\n/g, '$1<br/>');
    }

    static isObject(obj) {
        return typeof obj === 'object' && obj !== null;
    }

    static isObjectEqual(obj1, obj2) {
        return equal(obj1, obj2);
    };

    static isArrayEqual(array1 = [], array2 = []) {
        if (array1 === array2) {
            return true;
        }

        // check one level deep
        return array1.length === array2.length &&
            array1.every((item, index) => item === array2[index]);
    };

    static enableFog() {
        $('.bodyFog').addClass('active');
    }

    static disableFog() {
        $('.bodyFog').removeClass('active');
    }

    static setCrossDomainCookie(name, value, expire = null) {
        let domain = '.' + window.location.hostname.replace('m.', '');
        $.cookie(name, value, { domain: domain, path: '/', expire: expire });
    }

    static moveToMobileVersion() {
        $.removeCookie('fullSite');
        let parsedUri = window.location.href.split(window.location.host)[1];
        window.location.href = (window.appConfig['view.mobile_site_url'] + parsedUri).replace(/\/+$/g, '/');
    }

    static moveToFullSiteVersion() {
        utils.setCrossDomainCookie('fullSite', '1');
        let parsedUri = window.location.href.split(window.location.host)[1];
        window.location.href = (window.appConfig['view.full_site_url'] + parsedUri).replace(/\/+$/g, '/');
    }

    static getLocalizeUrl(route, language = null) {
        if (!language) {
            language = Language.getCurrentLanguage();
        }
        let defaultLang = window.appSettings['application.default_lang'],
            availableLang = window.appSettings['application.available_langs'],
            routeComponents = route.split('/');
        if (routeComponents[0] === '') {
            routeComponents.shift();
        }
        let lang = routeComponents[0];
        if (availableLang.indexOf(lang) !== -1) {
            routeComponents.shift();
        }
        route = '/' + (language === defaultLang ? '' : language + '/') + routeComponents.join('/');

        return route === '/' ? route : route.replace(/\/+$/, '');
    }
    static trim(value) {
        value = value || '';
        return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
    static leadingZero(value, zeroCount) {
        return ('00000000' + String(value)).slice(-zeroCount);
    }
    static getZeros(count) {
        return '000000000000000000000000000000000000000000000000000000000000000000000000'.slice(0, count);
    }
    static formatSlashes(aString) {
        return aString.replace(/\\\"/g, "\"");
    }
    static splitByBr(string) {
        return string.split(/<br>|<br\/>|<br \/>/);
    }
    static translite(str) {
        return str.replace(transliteReg, transliteReplacer);
    }
    static getRubForRubtOrUsual(currency) {
        return (currency.shortName == 'RUBT' ? 'RUB' : currency.shortName);
    }
    static getDisplayOrRealName(currency) {
        return (currency.shortDisplayName || currency.shortName);
    }
    static parseQuery = (() => {
        const re = /([^&=]+)=?([^&]*)/g;
        const decode = function (str) {
            return decodeURIComponent(str.replace(/\+/g, ' '));
        };
        return function (query) {
            var params = {}, e;
            if (query) {
                if (query.substr(0, 1) == '?') {
                    query = query.substr(1);
                }

                while (e = re.exec(query)) {
                    var k = decode(e[1]);
                    var v = decode(e[2]);
                    if (params[k] !== undefined) {
                        if (!$.isArray(params[k])) {
                            params[k] = [params[k]];
                        }
                        params[k].push(v);
                    } else {
                        params[k] = v;
                    }
                }
            }
            return params;
        };
    })()
}

// window.onload = () => {
//     utils.app_noty({ type: 'error', text: 'testing123' });
//     utils.app_noty({ type: 'info', text: 'testing' });
//     utils.app_noty({ type: 'success', text: 'Срок зачисления - моментально. Для перевода свыше 15 000 требуется паспорт гражданина РФ. Оплата без комиссии только на кассе, при оплате через терминал может взиматься комиссия.' });
//     utils.app_noty({ type: 'notification', text: 'testing' });
//     utils.app_noty({ type: 'warning', text: 'testing' });
// };


export default utils;
